import React from 'react';
import { Activity, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { HealthEntry } from '../../types';

interface HistoryViewProps {
  history: HealthEntry[];
  setSelectedLog: (log: HealthEntry) => void;
  formatDateFR: (date: string) => string;
  formatTimeFR: (date: string) => string;
}

export const HistoryView: React.FC<HistoryViewProps> = ({
  history,
  setSelectedLog,
  formatDateFR,
  formatTimeFR
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-black px-2">{t('app:history.title')}</h2>
      {history.map(entry => (
        <div 
          key={entry.id} 
          onClick={() => setSelectedLog(entry)} 
          className="bg-white p-5 rounded-3xl border border-gray-100 shadow-sm flex items-center justify-between cursor-pointer"
        >
          <div className="flex items-center gap-4">
            <div className={`w-12 h-12 rounded-2xl flex items-center justify-center ${
              entry.mood === 'joyeux' ? 'bg-green-50 text-green-600' : 'bg-gray-50 text-gray-500'
            }`}>
              <Activity size={20}/>
            </div>
            <div>
              <div className="flex gap-2 items-center">
                <p className="font-black text-gray-900">{formatDateFR(entry.date)}</p>
                <span className="text-xs text-gray-400 bg-gray-50 px-1.5 rounded">{formatTimeFR(entry.date)}</span>
              </div>
              <p className="text-xs text-gray-400 font-bold uppercase mt-1">
                {entry.weight && `${entry.weight}kg • `}{entry.mood || t('app:history.note')}
              </p>
            </div>
          </div>
          <ChevronRight className="text-gray-300" size={20} />
        </div>
      ))}
    </div>
  );
};
